/* eslint-disable import/no-cycle */
import axios from 'axios'
import moment from 'moment'
// eslint-disable-next-line import/no-cycle
import store from '../store'
import { Loading } from 'element-ui'
import { Message } from '@qs/ui'
import * as Sentry from '@sentry/vue'

import {
  getTenantId,
  getToken, getTokenExpires, gotoNewWindow,
} from '@/utils/auth'
import { getRequestJudge, setIsReject, getIsReject } from './multiTenantUtil'

let preRefreshToken = ''

/**
 * 是否执行刷新 token
 * 当前服务端定义的 token 有效期为 2 小时
 * 前端做检查 如果 token 有效期 - 当前时间 < 5 分钟则执行次刷新
 */
const needRefreshToken = () => {
  const token = getToken()
  const expires = getTokenExpires()
  const currentTime = moment().valueOf()

  if ((preRefreshToken !== token) && expires > 0 && ((expires - currentTime) < (5 * 60 * 1000))) {
    preRefreshToken = token
    store.dispatch('RefreshToken')
  }
}

// 创建axios实例
const service = axios.create({
  timeout: 60000 * 3, // 请求超时时间
})

// request拦截器
service.interceptors.request.use(
  (config) => {
    config.headers._admin_ts = moment().unix() // 时间戳(秒)  long
    config.headers._admin_eid = getTenantId() // 商户ID  long

    // 接口请求上报sentry(包含request参数)
    Sentry.captureMessage(config.url, {
      extra: {
        requestBody: config.data, // 请求参数
      },
    })

    const {
      token,
    } = store.getters

    if (token) {
      config.headers._admin_tk = token // 让每个请求携带自定义token 请根据实际情况自行修改
    }
    // 是否需要重新跳转到welcome页面
    if (getRequestJudge(config.url)) {
      if (!getIsReject()) {
        Loading.service()
        setTimeout(() => {
          gotoNewWindow()
        }, 2000)
        Message({
          message: '账户租户权限更新，返回首页。',
          type: 'error',
          duration: 2 * 1000,
        })
      }
      setIsReject()
      return Promise.reject()
    }
    return config
  },
  (error) => {
    Promise.reject(error)
  },
)

// response 拦截器
service.interceptors.response.use(
  (response) => {
    const res = response.data
    if (response.config && response.config.isExport) {
      return response.data
    }
    if (!res || res.code !== 1) {
      // 如果有要特殊处理的错误信息的时候
      let errorCode = response.config.headers._che_error_code
      if (errorCode) {
        // eslint-disable-next-line no-nested-ternary
        errorCode = typeof errorCode !== 'object' ? errorCode : errorCode.length ? errorCode : Object.values(errorCode)
      }
      if (errorCode && errorCode.indexOf(res.code) > -1) {
        return Promise.reject(res) // TODO: 这个设计不好，既然是业务代码，就不应该视为异常，应该直接return 而不是reject，后续要改掉
      }
      // 无权限不提示
      if (res.code === 20010) {
        return res
      }

      // 用户未登录 退出登录
      if (res.code === 20004) {
        return store.dispatch('FedLogOut').then(() => {
          location.reload()
        })
      }

      res.msg && Message({
        message: res.msg,
        type: 'error',
        duration: 5 * 1000,
      })

      // 导入失败 弹窗提示
      if (res.code === 23023) {
        return res
      }

      return res
    } else {
      needRefreshToken()
      return response.data
    }
  },
  (error) => {
    // 暂时注释埋点上报
    if (error.message.includes('timeout')) {
      return Promise.reject(error)
    }
    /**
     * 转化响应类型，优化cancel提示
     */
    if (axios.isCancel(error)) {
      return Promise.reject({
        msg: '请勿重复请求',
        code: 90000,
      })
    }
    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000,
    })
    return Promise.reject(error)
  },
)

export default service
